"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/Room/History/Mobile/SessionDetails.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _ParticipantDetails = require('./ParticipantDetails'); var _ParticipantDetails2 = _interopRequireDefault(_ParticipantDetails);
var _helpers = require('web/components/VideoRooms/Room/History/helpers');

var _LoadingSpinner = require('web/components/VideoRooms/Room/History/LoadingSpinner'); var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);








const MobileSessionDetails = ({
  roomKey,
  roomName,
  currentSessionKey,
  gotoHistory,
}) => {
  const [session, setSession] = _react.useState(undefined)

  // componentDidMount: the session is fetched once, for the keys at mount.
  _react.useLayoutEffect.call(void 0, () => {
    // SAFETY: VideoRoomSessionFetch answers with the session; a failed fetch
    // resolves undefined and the spinner stays, as in JS.
    _actions2.default.fetchVideoRoomSession({ RoomKey: roomKey, RoomSessionKey: currentSessionKey })
      .then(fetched => setSession(fetched ))
  // oxlint-disable-next-line react-hooks/exhaustive-deps -- mount only, like componentDidMount
  }, [])

  const renderHistoryBody = () => {
    if (!session) return null
    const { startedAt, duration } = _helpers.formatTimingLabels.call(void 0, session.StartedAt, session.EndedAt)

    return (
      _react2.default.createElement('div', { className: "meeting-room--mobile-history--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
        , _react2.default.createElement('span', {
          onClick: gotoHistory,
          className: "meeting-room--history--header-back", __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
, "Back to all"

        )
        , _react2.default.createElement('div', { className: "meeting-room--mobile-history--meeting-desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
          , _react2.default.createElement('span', { className: "meeting-room--mobile-history--meeting-desc-time", __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}},  startedAt )
          , _react2.default.createElement('span', { className: "meeting-room--mobile-history--meeting-desc-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}},  roomName )
          , _react2.default.createElement('span', { className: "meeting-room--mobile-history--meeting-desc-duration", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}},  duration )
        )
        , _react2.default.createElement('div', { className: "meeting-room--mobile-history--sessions-list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
          , _react2.default.createElement('h5', { className: "meeting-room--mobile-history--details-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}, "Participant Details" )
          , 
            session.RoomUsers.map((u, i) => {
              const { startedAt, duration } = _helpers.formatTimingLabels.call(void 0, u.InitialJoinedAt, u.LastDisconnectedAt)
              return (
                _react2.default.createElement(_ParticipantDetails2.default, {
                  key: i,
                  participantName: u.RoomUserName,
                  startedAt: startedAt,
                  duration: duration,
                  rating: u.Rating || 0, __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
                )
              )
            })
          
        )
      )
    )
  }

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  session
        ? renderHistoryBody()
        : (
          _react2.default.createElement('div', { className: "meeting-room--mobile-history--spinner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
            , _react2.default.createElement(_LoadingSpinner2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 76}} )
          )
          )
      
    )
  )
}

exports. default = MobileSessionDetails
